export default {
  name: 'my-workout',
  components: {},
  props: [],
  data() {
    return {
      activeContent: {
        one: false,
        second: false,
        three: false,
        four: false
      }
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    toggleContent(data) {
      if (this.activeContent.hasOwnProperty(data)) {
        this.activeContent[data] = !this.activeContent[data];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/SuccessStories/SuccessStories.js